import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { CaretDownOutlined, ControlFilled, DatabaseFilled, EnvironmentFilled, ExportOutlined, FileTextFilled, IdcardFilled, KeyOutlined, MessageFilled, PieChartFilled, PushpinFilled, SafetyCertificateFilled, SettingFilled, TagsFilled, TeamOutlined } from '@ant-design/icons'
import { ROUTES } from '../../constants/Routing'
import { HasSubMenu, Logo, SidebarMenu, SidebarWrapper, SingleMenu, SubMenu, SubMenuWrapper } from './sidebar.styled'
import useLogo from '../../hook/useLogo'

function Sidebar (props) {
  const [subActive, setSubActive] = useState(true)
  const user = useSelector((state) => state.user)
  const admin = useSelector((state) => state.admin)
  const [menu, setMenu] = useState({ admin: [], user: [] })
  const { t: ln_t } = useTranslation()
  const location = useLocation()
  const { pathname } = location || {}
  const adminMode = pathname.includes(ROUTES.ADMIN_ROOT)
  const logo = useLogo({ sidebar: true, fontSize: '30px' })

  const iconMatch = {
    dashboard: <PieChartFilled />,
    dataSource: <DatabaseFilled />,
    segment: <ControlFilled />,
    targeting: <PushpinFilled />,
    consumer360: <IdcardFilled />,
    managementItems: <SettingFilled />,
    location: <EnvironmentFilled />,
    account: <TeamOutlined />,
    adminAccount: <SafetyCertificateFilled />,
    taxonomy: <TagsFilled />,
    mappingKey: <KeyOutlined />,
    export: <ExportOutlined />,
    consumerInsights: <FileTextFilled />,
    chat: <MessageFilled />
  }

  const active = item => pathname.includes(`/${item}`) && !pathname.includes('management') && (!pathname.includes('segmentSetting') || !item.includes('segment'))

  // Define hidden function keys (permissions-only, not UI menu items)
  const HIDDEN_FUNCTION_KEYS = ['genbi_access', 'invoice_data_access']

  useEffect(() => {
    const menus = {}
    if (admin.active && admin.functions) menus.admin = [...admin.functions]
    if (user.active) {
      const functions = user?.nowGroupUserFunctions.filter(item =>
        !HIDDEN_FUNCTION_KEYS.includes(item?.key) &&
        !item?.link.includes('/management') &&
        item?.link.length
      )
      const managementItems = user?.nowGroupUserFunctions.filter(item =>
        !HIDDEN_FUNCTION_KEYS.includes(item?.key) &&
        item?.link.includes('/management')
      )
      menus.user = [...functions, { managementItems }]
    }
    setMenu(menus)
  }, [user.nowGroupUserFunctions, admin.functions])

  return (
    <SidebarWrapper>
      <Logo>{logo}</Logo>
      <SidebarMenu>
        {menu[adminMode ? 'admin' : 'user']?.map((item) =>
          Object.keys(item).includes('managementItems')
            ? <div key={item}>
                <HasSubMenu active={active(Object.keys(item))} onClick={() => setSubActive(!subActive)}>
                  {iconMatch[Object.keys(item)[0]]}
                  <div>{ln_t(`sidebar.${Object.keys(item)[0]}`)}</div>
                  <CaretDownOutlined className={`sub-toggle ${subActive ? '' : 'hide'}`}/>
                </HasSubMenu>
                <SubMenuWrapper active={subActive}>
                    {item.managementItems.map((sub) => (
                      <SubMenu key={sub.key}>
                        <Link to={sub.link} className={`${pathname.includes(sub.link) ? 'active' : ''}`}>
                          {ln_t(`sidebar.${(sub.key)}`)}
                        </Link>
                      </SubMenu>
                    ))}
                </SubMenuWrapper>
              </div>
            : <SingleMenu key={item.key} active={active(item.key)}>
                <Link to={item.link}>{iconMatch[item.key]} {ln_t(`sidebar.${item.key}`)}</Link>
              </SingleMenu>
        )
        }
      </SidebarMenu>
    </SidebarWrapper>
  )
}

export default Sidebar
